module.exports = __webpack_public_path__ + "img/Diagnosis - Gray.9ea8eeb0.png";